/*
 * Tracking Reports - Shell (Controller)
 * Angular module: trackerbase-app.views.trackerbase-reports.reports-shell
 * State: tbReports (abstract)
 * Exposed Controller: ReportsShellCtrl
 * Controller in template as: reportsViewShell
 *
 */
import angular from "angular";

import Assert from "tbAssert";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import uiRouterModule from "@uirouter/angularjs";

import TrackerBaseReportsConstants from "./Constants";

import ReportsViewShellController from "./ReportsViewShellController";

function ReportsViewShellConfiguration($stateProvider, $urlRouterProvider) {

    Assert.StrictAssert($stateProvider != null, "Assertion Failure: Missing UI Router State Provider Dependency");
    Assert.StrictAssert($urlRouterProvider != null, "Assertion Failure: Missing UI Router Url Routing Provider Dependency");

    $stateProvider.state(TrackerBaseReportsConstants.rootStateName, {
        url: "/trackerbase-reports",
        abstract: true,
        template: ReportsViewShellController.template,
        controller: ReportsViewShellController,
        controllerAs: ReportsViewShellController.controllerAs,
        data: {
            requiresLogin: true
        }
    });

    $urlRouterProvider.when("/trackerbase-reports", "/trackerbase-reports/reports");
}

ReportsViewShellConfiguration.$inject = [ "$stateProvider", "$urlRouterProvider" ];

ReportsViewShellConfiguration.dependencies = [ uiRouterModule ];

const reportsViewShellModuleDependencies = DependencyListBuilder([
    ReportsViewShellController.dependencies,
    ReportsViewShellConfiguration.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.trackerbase-reports.reports-shell",
        reportsViewShellModuleDependencies
    )
    .config(ReportsViewShellConfiguration)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/ReportsShell.js
// module id = 1RM8
// module chunks = 1